
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-lg fixed w-full top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/1c25e8811aca7c6ca186f30e4b2227d5/51a8b2bb6a60d7e2f0266258d766b012.png" 
              alt="Oxigênio Iturama Multigás" 
              className="h-12 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('inicio')}
              className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer"
            >
              Início
            </button>
            <button 
              onClick={() => scrollToSection('pedido')}
              className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer"
            >
              Fazer Pedido
            </button>
            <button 
              onClick={() => scrollToSection('servicos')}
              className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer"
            >
              Serviços
            </button>
            <button 
              onClick={() => scrollToSection('contato')}
              className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer"
            >
              Contato
            </button>
            <button 
              onClick={() => scrollToSection('pedido')}
              className="bg-red-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Peça Agora
            </button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <nav className="py-4 space-y-2">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:text-red-600 hover:bg-gray-50 transition-colors cursor-pointer"
              >
                Início
              </button>
              <button 
                onClick={() => scrollToSection('pedido')}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:text-red-600 hover:bg-gray-50 transition-colors cursor-pointer"
              >
                Fazer Pedido
              </button>
              <button 
                onClick={() => scrollToSection('servicos')}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:text-red-600 hover:bg-gray-50 transition-colors cursor-pointer"
              >
                Serviços
              </button>
              <button 
                onClick={() => scrollToSection('contato')}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:text-red-600 hover:bg-gray-50 transition-colors cursor-pointer"
              >
                Contato
              </button>
              <div className="px-4 pt-2">
                <button 
                  onClick={() => scrollToSection('pedido')}
                  className="w-full bg-red-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Peça Agora
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
